module.exports = __webpack_public_path__ + "img/vuelogo.82b9c7a5.png";